

import { Box } from '@mui/material';
import React from 'react'

const ChipComponent = ({ value, color, size = 'default', chipWidth, chipHeight }) => {
    const sizeMap = {
        small: { width: '24px', height: '24px', fontSize: 8 },
        default: { width: '24px', height: '24px', fontSize: 8 },
        render: { width: '100%', height: '100%', fontSize: 10 }
    };

    const { width, height, fontSize } = sizeMap[size];

   
    const formatValue = (val) => {
        if (val >= 1000) return `${(val / 1000).toFixed(val % 1000 === 0 ? 0 : 1)}K`;
        return val;
    };

    return (
        <Box
            sx={{
                width: chipWidth ? `${chipWidth}px` : width,
                height: chipHeight ? `${chipHeight}px` : height,
                borderRadius: '50%',
                background: `radial-gradient(circle at center, ${color} 60%, ${color} 90%)`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                color: 'white',
                fontWeight: 'bold',
                fontSize: fontSize,
                overflow: 'hidden',
            }}
        >
            {[...Array(6)].map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        position: 'absolute',
                        width: '30%',
                        height: '80%',
                        backgroundColor: '#fff',
                        transform: `rotate(${i * (360 / 6)}deg) translate(0, -100%)`,
                        transformOrigin: 'center',
                        borderRadius: '1px',
                    }}
                />
            ))}

            <Box
                sx={{
                    width: '50%',
                    height: '50%',
                    backgroundColor: color,
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '1em',
                    zIndex: 1,
                }}
            >
                {formatValue(value)} {/* ✅ 200 → 200, 1000 → 1K, 2000 → 2K */}
            </Box>
        </Box>
    );
};

export default ChipComponent;

